import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function clamp(value: number, min: number, max: number): number {
	return Math.min(max, Math.max(min, value))
}
